<div class="table-wrapper">
  <table mat-table cdkDropListGroup matSort [dataSource]="dataSource">
    <ng-container
      *ngFor="let column of columns$ | async; trackBy: trackByColumn"
      [matColumnDef]="column.definition.uid"
    >
      <th *matHeaderCellDef mat-header-cell mat-sort-header>
        <pr-report-builder-resolved-column-label
          [column]="column"
          [hideSubtitle]="true"
        />

        @if ((isViewingHistoricalRun$ | async) === false) {
          <button
            mat-icon-button
            class="small-button"
            [matMenuTriggerFor]="columnMenu"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #columnMenu="matMenu">
            <button mat-menu-item (click)="columnManager.edit(column.definition)">
              <mat-icon>edit</mat-icon> Edit
            </button>
            <button
              mat-menu-item
              (click)="columnManager.remove(column.definition)"
            >
              <mat-icon>delete</mat-icon> Remove
            </button>
            <mat-divider />
            <button
              mat-menu-item
              (click)="columnManager.moveLeft(column.definition)"
            >
              <mat-icon>arrow_back</mat-icon> Move Left
            </button>
            <button
              mat-menu-item
              (click)="columnManager.moveRight(column.definition)"
            >
              <mat-icon>arrow_forward</mat-icon> Move Right
            </button>
            <mat-divider />
            <button
              mat-menu-item
              (click)="columnManager.addLeft(column.definition)"
            >
              <mat-icon>add</mat-icon> Add Column Left
            </button>
            <button
              mat-menu-item
              (click)="columnManager.addRight(column.definition)"
            >
              <mat-icon>add</mat-icon> Add Column Right
            </button>
          </mat-menu>
        }
      </th>
      <td *matCellDef="let row" mat-cell>
        @if ({ row, column } | map: getDataPoint : this; as dataPoint) {
          @if (dataPoint | map: isLink) {
            @if (dataPoint | map: hasValidLink) {
              <a target="_blank" href="{{ dataPoint | metric }}"
                >Open Link <mat-icon class="icon-xxs">open_in_new</mat-icon></a
              >
            }
          } @else if (dataPoint | map: isText) {
            <span
              class="text"
              matTooltipShowDelay="500"
              [matTooltip]="dataPoint | metric"
            >
              {{ dataPoint | metric }}
            </span>
          } @else {
            {{ dataPoint | metric }}
          }
        }
      </td>
    </ng-container>

    <tr *matHeaderRowDef="columnIds$ | async" mat-header-row></tr>
    <tr *matRowDef="let row; columns: columnIds$ | async" mat-row></tr>
  </table>

  <div class="sticky inset-x-0">
    @if (store.results$ | async) {
      @if (store.hasNoData$ | async) {
        <div
          class="flex h-80 flex-col items-center justify-center gap-1 bg-slate-100 p-4"
        >
          <mat-icon
            class="text-slate-500 opacity-50"
            fontSet="material-symbols"
          >
            manage_search
          </mat-icon>
          <div class="text-center text-xs text-slate-500 opacity-50">
            No data found
          </div>
        </div>
      } @else {
        <mat-paginator
          showFirstLastButtons
          [pageSizeOptions]="pageSizeOptions"
        />
      }
    } @else if (store.isLoading$ | async) {
      <div
        class="flex h-80 flex-col items-center justify-center gap-1 bg-slate-100 p-4"
      >
        <mat-spinner diameter="36" color="default" class="grayscale" />
        <div class="text-center text-xs text-slate-500 opacity-50">
          Loading Data...
        </div>
      </div>
    } @else {
      <div
        class="flex h-80 flex-col items-center justify-center gap-1 bg-slate-100 p-4"
      >
        <mat-icon class="text-slate-500 opacity-50" fontSet="material-symbols">
          data_table
        </mat-icon>
        <div class="text-center text-xs text-slate-500 opacity-50">
          Run report to load data
        </div>
      </div>
    }
  </div>
</div>
